export default __webpack_public_path__ + "static/static-asset-fancyFreeMonth-7e643c7dc99bdaa7da41040473655e11.svg";